var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunPlaceholderElement_instances, _DuoyunPlaceholderElement_mode_get, _DuoyunPlaceholderElement_maxLine_get, _DuoyunPlaceholderElement_minLine_get;
import { adoptedStyle, customElement, attribute, boolattribute, numattribute } from '@mantou/gem/lib/decorators';
import { html } from '@mantou/gem/lib/element';
import { createCSSSheet, css, styleMap } from '@mantou/gem/lib/utils';
import { theme } from '../lib/theme';
import { DuoyunVisibleBaseElement } from './base/visible';
const style = createCSSSheet(css `
  :host {
    display: block;
    flex-grow: 1;
  }
  :host(:not([mode='multi'])) {
    display: flex;
    align-content: center;
  }
  :host([center]) {
    justify-content: center;
  }
  .content {
    background-image: linear-gradient(${theme.lightBackgroundColor}, ${theme.lightBackgroundColor});
    background-position-y: center;
    background-size: 100% 1em;
    background-repeat: no-repeat;
  }
`);
/**
 * @customElement dy-placeholder
 * @attr mode
 * @attr width
 * @attr center
 * @attr max-line
 * @attr min-line
 */
let DuoyunPlaceholderElement = class DuoyunPlaceholderElement extends DuoyunVisibleBaseElement {
    constructor() {
        super();
        _DuoyunPlaceholderElement_instances.add(this);
        this.render = () => {
            const lineCount = __classPrivateFieldGet(this, _DuoyunPlaceholderElement_instances, "a", _DuoyunPlaceholderElement_mode_get) === 'single' ? 1 : Math.round(__classPrivateFieldGet(this, _DuoyunPlaceholderElement_instances, "a", _DuoyunPlaceholderElement_minLine_get) + Math.random() * (__classPrivateFieldGet(this, _DuoyunPlaceholderElement_instances, "a", _DuoyunPlaceholderElement_maxLine_get) - __classPrivateFieldGet(this, _DuoyunPlaceholderElement_instances, "a", _DuoyunPlaceholderElement_minLine_get)));
            return html `${Array(lineCount)
                .fill(null)
                .map((_, index) => html `
            <div
              class="content"
              style=${styleMap({
                width: index === lineCount - 1 ? this.width || `${50 + Math.random() * 50}%` : 'auto',
            })}
            >
              &ZeroWidthSpace;
            </div>
          `)}`;
        };
        this.internals.role = 'progressbar';
        this.internals.ariaBusy = 'true';
    }
};
_DuoyunPlaceholderElement_instances = new WeakSet(), _DuoyunPlaceholderElement_mode_get = function _DuoyunPlaceholderElement_mode_get() {
    return this.mode || 'single';
}, _DuoyunPlaceholderElement_maxLine_get = function _DuoyunPlaceholderElement_maxLine_get() {
    return this.maxLine || 3;
}, _DuoyunPlaceholderElement_minLine_get = function _DuoyunPlaceholderElement_minLine_get() {
    return this.minLine || 1;
};
__decorate([
    attribute
], DuoyunPlaceholderElement.prototype, "mode", void 0);
__decorate([
    boolattribute
], DuoyunPlaceholderElement.prototype, "center", void 0);
__decorate([
    attribute
], DuoyunPlaceholderElement.prototype, "width", void 0);
__decorate([
    numattribute
], DuoyunPlaceholderElement.prototype, "maxLine", void 0);
__decorate([
    numattribute
], DuoyunPlaceholderElement.prototype, "minLine", void 0);
DuoyunPlaceholderElement = __decorate([
    customElement('dy-placeholder'),
    adoptedStyle(style)
], DuoyunPlaceholderElement);
export { DuoyunPlaceholderElement };
//# sourceMappingURL=placeholder.js.map